import styled from 'styled-components'
import colors from 'globals/colors'
import measures from 'globals/measures'

interface SideMenuWrapperProps {
  active: boolean
}

export const SideMenuWrapper = styled.div<SideMenuWrapperProps>`
  width: 168px;
  background: ${colors.purple};
  padding: 18px 16px 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  
  @media(max-width: ${measures.tabletThreshold}px) {
    width: 300px;
    height: 100%;
    background: white;
    padding: 20px 25px 0;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1002;
    
    transform: translateX(-320px);
    transition: all 300ms;
    
    ${(props) => props.active && `
      transform: translateX(0px);
    `};
  }

  @media(max-width: ${measures.mobileThreshold}px) {
    width: 100%;
    height: 100%;
    box-shadow: none;
    
    transform: translateX(-100%);
    
    ${(props) => props.active && `
      transform: translateX(0%);
    `};
  }
`

export const LogoWrapper = styled.div`
  margin-bottom: 70px;
  
  img + img {
    display: none;
  }

  @media(max-width: ${measures.tabletThreshold}px) {
    margin-bottom: 43px;
    
    img {
      display: none;
    }
    
    img + img {
      display: inline;
    }
  }
`

export const MobileHeader = styled.div`
  height: 72px;
  background: ${colors.lighterGrey};
  border-bottom: 1px solid ${colors.lightGrey};
  display: none;
  justify-content: space-between;
  
  @media(max-width: ${measures.tabletThreshold}px) {
    display: flex;
  }
`

export const MobileLogoWrapper = styled.div`
  width: 72px;
  background: ${colors.purple};
  display: flex;
  align-items: center;
  justify-content: center;
`

export const Burger = styled.div`
  width: 72px;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const MobileClose = styled.div`
  width: 72px;
  height: 72px;
  position: absolute;
  right: 0;
  top: 6px;
  display: none;
  align-items: center;
  justify-content: center;
  
  @media(max-width: ${measures.tabletThreshold}px) {
    display: flex;
  }
`

export const MobileCentersChoice = styled.div`
  color: ${colors.purple};
  border-top: 1px solid ${colors.lightGrey};
  padding-top: 4px;
  margin-top: 14px;
  display: none;
  flex-direction: column;
  flex: 1;
  overflow: hidden;

  @media(max-width: ${measures.tabletThreshold}px) {
    display: flex;
  }
`

export const MobileCentersTitle = styled.div`
  line-height: 50px;
  font-size: 16px;
  font-weight: bold;
  display: flex;
  align-items: center;
  
  & > span {
    flex: 1;
  }
  
  & > svg .color-fill {
    fill: ${colors.purple};
  }
`

interface MobileCentersListProps {
  show: boolean
}

export const MobileCentersList = styled.div<MobileCentersListProps>`
  display: ${(props) => props.show ? 'block': 'none'};
  flex: 1;
  overflow: auto;
`

interface MobileCenterChoiceProps {
  selected: boolean
}

export const MobileCenterChoice = styled.div<MobileCenterChoiceProps>`
  line-height: 40px;
  
  & > svg {
    display: none;
    margin-left: 10px;
    
    & .color-stroke {
      stroke: ${colors.purple};
    }
  }
  
  ${(props) => props.selected && `
    font-weight: bold;
    
    & > svg {
      display: inline;
    }
  `};
`

export const DesktopLogout = styled.div`
  display: none;
  height: 100%;
  align-items: flex-end;
  padding-bottom: 16px;

  @media(min-width: ${measures.tabletThreshold}px) {
    display: flex;
  }
`

export const MobileLogout = styled.div`
  display: none;
  
  @media(max-width: ${measures.tabletThreshold}px) {
    display: block;
  }
  
  & > button.ant-btn {
    height: 75px;
    width: calc(100% + 32px);
    border-radius: 0;
    margin-left: -16px;

    @media(max-width: ${measures.tabletThreshold}px) {
      width: calc(100% + 50px);
      margin-left: -25px;
    }
  }
`
